module.exports = __webpack_public_path__ + "img/jovem-aprendiz-thumb.cb064852.jpg";